import * as React from 'react';
import { Box, Card, CardActionArea, CardContent, Grid, Stack, Typography } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import DocumentOverview from './DocumentOverview';
import CompanyOverview from './CompanyOverview';

function UsageOverview() {
  const [selectedOverview, setSelectedOverview] = React.useState<'usageOverview' | 'document' | 'company'>('usageOverview');

  const handleLinkClick = (overview: 'document' | 'company') => {
    setSelectedOverview(overview);
  };

  const cards = [
    {
      key: 'document' as const,
      title: 'Per Dokument',
      description: 'Se brukstall per anvisning og drill ned til kunde- og brukerdetaljer.',
      icon: <DescriptionIcon />,
    },
    {
      key: 'company' as const,
      title: 'Per Firma',
      description: 'Se bruksmønster per firma og gå videre til detaljert aktivitetsanalyse.',
      icon: <BusinessIcon />,
    },
  ];

  return (
    <>
      {selectedOverview === 'usageOverview' && (
        <Box>
          <Typography variant="h5" gutterBottom>
            Bruksrapport
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 3
            }}>
            Velg visning for å jobbe stegvis med dokument- eller firmabasert bruksanalyse.
          </Typography>
          <Grid container spacing={2}>
            {cards.map((card) => (
              <Grid
                key={card.key}
                size={{
                  xs: 12,
                  md: 4
                }}>
                <Card variant="outlined">
                  <CardActionArea onClick={() => handleLinkClick(card.key)}>
                    <CardContent>
                      <Stack spacing={1.5}>
                        <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
                          {card.icon}
                          <Typography variant="h6">{card.title}</Typography>
                        </Stack>
                        <Typography variant="body2" sx={{
                          color: "text.secondary"
                        }}>
                          {card.description}
                        </Typography>
                        <Typography variant="body2" color="primary" sx={{ fontWeight: 600 }}>
                          Åpne rapport
                        </Typography>
                      </Stack>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      {selectedOverview === 'document' && <DocumentOverview onBackClick={() => setSelectedOverview('usageOverview')} />}
      {selectedOverview === 'company' && <CompanyOverview onBackClick={() => setSelectedOverview('usageOverview')} />}
    </>
  );
}

export default UsageOverview;
